import { render, staticRenderFns } from "./ServicesRegistryEditForm.vue?vue&type=template&id=54a55e72"
import script from "./ServicesRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./ServicesRegistryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports